import * as React from "react";
import * as Autosuggest from 'react-autosuggest';
import InputMask from 'react-input-mask';

import CustomSelect from "../../../shared/custom-select/CustomSelect";
import { Header, Navigation, Footer } from "../../../shared";
import { AdministrationMenu } from "../../shared/menu/AdministrationMenu";
import { TableBookstores } from './TableBookstores';
import "./BookstoresRegister.scss";

import {
  Button,
  Card,
  CardActions,
  CardContent,
  Grid,
  TextField,
  Paper,
  Snackbar,
  SnackbarContent,
  Typography,
  Switch,
  FormControlLabel,
  FormGroup,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@material-ui/core';

import StoreMallDirectoryIcon from '@material-ui/icons/StoreMallDirectory';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

import Rest from "../../../../services/Rest";

const styles = {
  textField: {
    marginLeft: 5,
    marginRight: 5,
  },
};

const ufs = [
    {"name": "Acre", "uf": "AC"},
    {"name": "Alagoas", "uf": "AL"},
    {"name": "Amapá", "uf": "AP"},
    {"name": "Amazonas", "uf": "AM"},
    {"name": "Bahia", "uf": "BA"},
    {"name": "Ceará", "uf": "CE"},
    {"name": "Distrito Federal", "uf": "DF"},
    {"name": "Espírito Santo", "uf": "ES"},
    {"name": "Goiás", "uf": "GO"},
    {"name": "Maranhão", "uf": "MA"},
    {"name": "Mato Grosso", "uf": "MT"},
    {"name": "Mato Grosso do Sul", "uf": "MS"},
    {"name": "Minas Gerais", "uf": "MG"},
    {"name": "Pará", "uf": "PA"},
    {"name": "Paraíba", "uf": "PB"},
    {"name": "Paraná", "uf": "PR"},
    {"name": "Pernambuco", "uf": "PE"},
    {"name": "Piauí", "uf": "PI"},
    {"name": "Rio de Janeiro", "uf": "RJ"},
    {"name": "Rio Grande do Norte", "uf": "RN"},
    {"name": "Rio Grande do Sul", "uf": "RS"},
    {"name": "Rondônia", "uf": "RO"},
    {"name": "Roraima", "uf": "RR"},
    {"name": "Santa Catarina", "uf": "SC"},
    {"name": "São Paulo", "uf": "SP"},
    {"name": "Sergipe", "uf": "SE"},
    {"name": "Tocantins", "uf": "TO"}

];

const coleta = [
    {"name": "Banco de Dados", "tipo": "BANCO_DADOS"},
    {"name": "Formato Padrão", "tipo": "PADRAO"},
    {"name": "Arquivo XML", "tipo": "XML"},
    {"name": "API", "tipo": "API"},
    {"name": "Importação Excel", "tipo": "IMPORTACAO_EXCEL"}
];

const QUERY_SAVE_BOOKSTORES = ` query saveBookstoreRegister($customFilter: BookstoreFilter) { saveBookstoreRegister(bookstoreFilter: $customFilter) { address,alerta_dias_sem_venda,cnpj,county,erp_coleta_venda,group_id,group_name,id,ignore_discount,cnpj_monitoria_coletor,name,preprd_id,state,tipo_coleta_venda,zipcode } } `;

const QUERY_GET_GROUP = ` query { economicGroup { id, name } } `;

// tslint:disable-next-line:no-empty-interface
export interface IBookstoresRegisterProps {
}

// tslint:disable-next-line:no-empty-interface
export interface IBookstoresRegisterState {
    alertMessage: string,
    alertOpened: boolean,
    alertType: string,
    fixedSuggestions: any[],
    monitorList: any[],
    store: {
        address: string,
        alerta_dias_sem_venda: number,
        cnpj: string,
        cnpj_monitoria_coletor: string,
        county: string,
        erp_coleta_venda: string,
        group_id: number,
        group_name: string,
        id: number,
        ignore_discount: boolean,
        name: string,
        preprd_id: number,
        state: string,
        tipo_coleta_venda: string,
        zipcode: string,
    },
    suggestions: any[],
    value: string
}

export class BookstoresRegister extends React.Component<IBookstoresRegisterProps, IBookstoresRegisterState> {

    private tableBookstores: React.RefObject<TableBookstores>;
    constructor(props: IBookstoresRegisterProps) {
        super(props);
        this.tableBookstores = React.createRef();

        this.state = {
            alertMessage: '',
            alertOpened: false,
            alertType: 'success',
            fixedSuggestions:[],
            monitorList: [],
            store: {
                address: '',
                alerta_dias_sem_venda: 0,
                cnpj: '',
                cnpj_monitoria_coletor: '',
                county: '',
                erp_coleta_venda: '',
                group_id: 0,
                group_name: '',
                id: 0,
                ignore_discount: false,
                name: '',
                preprd_id: 0,
                state: '',
                tipo_coleta_venda: '',
                zipcode: ''
            },
            suggestions: [],
            value: ''
        }

        this.searchBookstore = this.searchBookstore.bind(this);
        this.receiveBookstoreToEdit = this.receiveBookstoreToEdit.bind(this);
    }

    public receiveBookstoreToEdit (store:any) {
        this.setState( {store} );
    }

    public componentWillMount () {

        const body = {
            "operationName":"",
            "query":QUERY_GET_GROUP
        };

        Rest.GraphqlPOST(body)
            .then( result  => {
                this.setState({ fixedSuggestions: result.data.data.economicGroup
                })
            });
        
        Rest.GET('keep-alive/list-cnpj', null)
            .then((response) => response.json())
            .then((result: any) => {
                console.log('result => ', result)
                if (!!result) {
                    if (result.error) {
                        this.openAlert(true, 'error', result.message || 'Erro ao carregar lista monitoria');
                        return;
                    }
                    this.setState({ monitorList: result });
                }
            })
    }

    
    public render() {

        const { value, suggestions } = this.state;

        // Autosuggest will pass through all these props to the input.
        const inputProps = {
            onChange: this.onChange,
            placeholder: 'Nome *',
            value
        };

        return (
        <div className="stores-register-page">
            <Header title={"Cadastro de Lojas"} name={"Administrativo"} link={"/dashboard"} />

            <Navigation name={"Cadastro de Lojas"}
                linkDefault={"/administration/bookstores-register"}
                link={"/dashboard"}
                linkTitle={"Produtos"}
                painel={3}
                icon={<ChevronRightIcon />}
            />
        
            <div className="stores-register-body">
                <AdministrationMenu paramIcon={<StoreMallDirectoryIcon />} />

                <div className="wrapper">
                    <Grid
                        container={true}
                        className="stores-register-panel panel-grid"
                        spacing={16}
                    >

                        <Grid item={true} xs={12} >
                            <div>
                                <Paper className="bookstore-panel">
                                    <Grid container={true} direction="column" spacing={16}>
                                        <Grid item={true} style={{width:"100%"}}>
                                            <Snackbar
                                                anchorOrigin={{
                                                    horizontal: 'center',
                                                    vertical: 'center',
                                                }}
                                                open={this.state.alertOpened}
                                                autoHideDuration={4000}
                                                onClose={this.closeAlert}
                                            >
                                                <SnackbarContent message={this.state.alertMessage} style={this.alertStyle()}/>
                                            </Snackbar>
                                            
                                            <Card>
                                                <form>
                                                    <CardContent id="content-econnomic-group" >
                                                        <Typography variant="title" component="h2">
                                                            Grupo Econômico
                                                        </Typography>
                                                        
                                                        <FormGroup row={true}>
                                                            <div className="autocomplete-input">
                                                                <Autosuggest
                                                                    getSuggestionValue={this.getSuggestionValue}
                                                                    inputProps={inputProps}
                                                                    onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                                                                    onSuggestionSelected={this.onSuggestionSelected}
                                                                    onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                                                                    renderSuggestion={this.renderSuggestion}
                                                                    suggestions={suggestions}
                                                                />
                                                            </div>
                                                            <FormControlLabel
                                                                control={
                                                                    <Switch
                                                                        checked={this.state.store.group_id!=null && this.state.store.group_id!==undefined && this.state.store.group_id > 0}
                                                                        value=""
                                                                        onClick={this.handleCancellUserIteraction}
                                                                        color="primary"
                                                                    />
                                                                }
                                                                label="Grupo Existente"
                                                            />
                                                        </FormGroup>
                                                    </CardContent>
                                                    <CardContent id="content-store">
                                                        <Typography variant="title" component="h2">
                                                            Livraria
                                                        </Typography>
                                                    
                                                        <FormGroup row={true}>
                                                            <TextField
                                                                id="outlined-name-input"
                                                                label="Nome"
                                                                style={this.textFieldStyle()}
                                                                value={this.state.store.name}
                                                                onChange={this.handleChangeCadastro('name')}
                                                                type="text"
                                                                name="name"
                                                                autoComplete="text"
                                                                margin="normal"
                                                                className="formTextField"
                                                                required={true}
                                                            />

                                                            <InputMask 
                                                                mask="99.999.999/9999-99" 
                                                                name="cnpj"
                                                                value={this.state.store.cnpj}
                                                                onChange={this.handleChangeCadastro('cnpj')}
                                                            >
                                                                {() => 
                                                                    <TextField
                                                                        id="standard-cnpj-input"
                                                                        label="CNPJ"
                                                                        style={this.textFieldStyle()}
                                                                        type="text"
                                                                        autoComplete="text"
                                                                        margin="normal"
                                                                        className="formTextField"
                                                                        required={true}
                                                                    />
                                                                }
                                                            </InputMask>
                                                        </FormGroup>

                                                        <FormGroup row={true}>
                                                            <InputMask
                                                                mask="99.999.999" 
                                                                name="cep"
                                                                value={this.state.store.zipcode}
                                                                onChange={this.handleChangeCadastro('zipcode')}
                                                            >
                                                                {() => 
                                                                    <TextField
                                                                        id="standard-zipcode-input"
                                                                        label="Cep"
                                                                        style={this.textFieldStyle()}
                                                                        type="text"
                                                                        autoComplete="text"
                                                                        margin="normal"
                                                                        className="formTextField"
                                                                        required={true}
                                                                    />
                                                                }
                                                            </InputMask>

                                                            <TextField
                                                                id="standard-address-input"
                                                                label="Endereço"
                                                                value={this.state.store.address}
                                                                onChange={this.handleChangeCadastro('address')}
                                                                style={this.textFieldStyle()}
                                                                type="text"
                                                                autoComplete="text"
                                                                margin="normal"
                                                                className="formTextField"
                                                            />
                                                        </FormGroup>

                                                        <FormGroup row={true}>
                                                            <TextField
                                                                id="standard-county-input"
                                                                label="Município"
                                                                value={this.state.store.county}
                                                                onChange={this.handleChangeCadastro('county')}
                                                                style={this.textFieldStyle()}
                                                                type="text"
                                                                autoComplete="text"
                                                                margin="normal"
                                                                className="formTextField"
                                                            />

                                                            <FormControl className="stateSelectInput">
                                                                <InputLabel htmlFor="state">Estado</InputLabel>
                                                                <Select
                                                                    value={this.state.store.state}
                                                                    onChange={this.handleChangeSelect}
                                                                    inputProps={{
                                                                        id: 'state',
                                                                        name: 'state',
                                                                    }}
                                                                >
                                                                        {
                                                                            ufs.map((uf:any, key:number) => (
                                                                                <MenuItem key={uf.uf} value={uf.uf}>{uf.name}</MenuItem>
                                                                            ))
                                                                        }
                                                                </Select>
                                                            </FormControl>
                                                        </FormGroup>
                                                        <FormGroup row={true}>
                                                            <TextField
                                                               inputProps={{
                                                                max: 100,
                                                                min: 0,
                                                                type: 'number',
                                                               }}
                                                                id="outlined-name-input"
                                                                label="Quantidade dias alerta sem venda"
                                                                style={this.textFieldStyle()}
                                                                value={this.state.store.alerta_dias_sem_venda}
                                                                onChange={this.handleChangeCadastro('alerta_dias_sem_venda')}
                                                                type="number"
                                                                autoComplete="number"
                                                                margin="normal"
                                                                className="formTextField"
                                                                
                                                            />
                                                    
                                                            <TextField
                                                                id="outlined-name-input"
                                                                label="ERP"
                                                                style={this.textFieldStyle()}
                                                                value={this.state.store.erp_coleta_venda}
                                                                onChange={this.handleChangeCadastro('erp_coleta_venda')}
                                                                type="text"
                                                                autoComplete="text"
                                                                margin="normal"
                                                                className="formTextField"
                                                            />
                                                        </FormGroup>
                                                        <FormGroup row={true}>
                                                            <FormControl className="stateSelectInput">
                                                                <InputLabel htmlFor="tipo_coleta_venda">Tipo de Coleta</InputLabel>
                                                                <Select
                                                                    value={this.state.store.tipo_coleta_venda}
                                                                    onChange={this.handleChangeSelect}
                                                                    inputProps={{
                                                                        id: 'tipo_coleta_venda',
                                                                        name: 'tipo_coleta_venda',
                                                                    }}
                                                                >
                                                                        {
                                                                            coleta.map((tipo:any, key:number) => (
                                                                                <MenuItem key={tipo.tipo} value={tipo.tipo}>{tipo.name}</MenuItem>
                                                                            ))
                                                                        }
                                                                </Select>
                                                            </FormControl>
                                                            <FormControl className="stateSelectInput">
                                                                <InputLabel htmlFor="cnpj_monitoria_coletor">Monitoria</InputLabel>
                                                                <CustomSelect
                                                                    isClearable={true}
                                                                    value={this.state.store.cnpj_monitoria_coletor}
                                                                    onChange={this.handleChangeSelect}
                                                                    inputProps={{ id: 'cnpj_monitoria_coletor', name: 'cnpj_monitoria_coletor' }}
                                                                >
                                                                    {this.state.monitorList.map(monitor => (
                                                                        <MenuItem key={monitor.cnpj} value={monitor.cnpj}>{monitor.cnpj}</MenuItem>
                                                                    ))}
                                                                </CustomSelect>
                                                            </FormControl>
                                                        </FormGroup>
                                                        <FormControlLabel
                                                            label="Ignora Desconto"
                                                            control={
                                                                <Switch
                                                                    checked={this.state.store.ignore_discount}
                                                                    value=""
                                                                    onClick={this.handleDiscount}
                                                                    color="primary"
                                                                />
                                                            }
                                                        />
                                                    </CardContent>
                                                    <CardActions>
                                                        <Button className="filter-dialog-clear" onClick={this.handleClearAllForm} >
                                                            Limpar
                                                        </Button>
                                                        <Button className="filter-dialog-close" onClick={this.searchBookstore.bind(this,null)} color="primary">
                                                            Pesquisar
                                                        </Button>
                                                        <Button variant="contained" className="filter-dialog-close" onClick={this.saveUser} color="primary">
                                                            Salvar
                                                        </Button>
                                                    </CardActions>
                                                </form>
                                            </Card>
                                            <Card>
                                                <CardContent>
                                                    <TableBookstores search={this.searchBookstore.bind(this,null)} receiveBookstoreToEdit={this.receiveBookstoreToEdit} ref={this.tableBookstores} />
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </div>
            <div className="stores-register-footer">
                <Footer />
            </div>
        </div>
        );
    }

    private handleDiscount = () => {
        const store = this.state.store
        store.ignore_discount = !this.state.store.ignore_discount
        this.setState({ store })
    }

    private handleCancellUserIteraction = (event: any) => {
        event.stopPropagation();
    }

    private alertStyle = () => {
        return styles[this.state.alertType];
    }

    private textFieldStyle = () => {
        return Object.assign({}, styles.textField)
    }

    private searchBookstore = (previewStore:any) => {
        if(this!= null && this.tableBookstores != null && this.tableBookstores.current != null) {

            let dataToSearch = previewStore;
            if(!dataToSearch) {
                dataToSearch = this.state.store;
            }

            this.syncEconomicGroupStatusValue("");
            this.tableBookstores.current.changeState(
                this.prepareDataToBack(dataToSearch));
        }
    }

    private validDataForSave = () => {
        let messageValidation = 'É obrigatório informar: ';

        if(!this.state.store.cnpj) {
            messageValidation += " Cnpj.";
        }

        if(!this.state.store.name) {
            messageValidation += " Nome.";
        }

        if(!this.state.store.group_name) {
            messageValidation += " Nome do Grupo.";
        }

        if(messageValidation !== 'É obrigatório informar: ') {
            this.errorSaveStore(messageValidation);
            return false;
        }

        return  true;
    }

    private prepareDataToBack(dataToSend:any) {
        const re = /[\.\/\-]/gi;
        
        if(dataToSend.cnpj) {
            dataToSend.cnpj = dataToSend.cnpj.replace(re, "");
        }

        if(dataToSend.zipcode) {
            dataToSend.zipcode = dataToSend.zipcode.replace(re, "");
        }
        return dataToSend;
    }

    private saveUser = () => {
        this.syncEconomicGroupStatusValue("");

        if (this.validDataForSave()) {
            let customFilter : any = {
                "address": this.state.store.address,
                "alerta_dias_sem_venda": (this.state.store.alerta_dias_sem_venda > 0) ? this.state.store.alerta_dias_sem_venda : null,
                "cnpj": this.state.store.cnpj,
                "cnpj_monitoria_coletor": this.state.store.cnpj_monitoria_coletor,
                "county": this.state.store.county,
                "erp_coleta_venda": this.state.store.erp_coleta_venda,
                "group_id": this.state.store.group_id,
                "group_name": this.state.store.group_name,
                "id": this.state.store.id,
                "ignore_discount": this.state.store.ignore_discount,
                "name": this.state.store.name,
                "preprd_id": this.state.store.preprd_id,
                "state": this.state.store.state,
                "tipo_coleta_venda": this.state.store.tipo_coleta_venda,
                "zipcode": this.state.store.zipcode
            };

            customFilter = this.prepareDataToBack(customFilter);

            const body = {
                "operationName":"",
                "query":QUERY_SAVE_BOOKSTORES,
                "variables": {customFilter}
            };
        
            Rest.GraphqlPOST(body)
                .then( result  => {
                    if(result.data.errors && !result.data.data.saveBookstoreRegister) {
                        if(result.data.errors[0].message && result.data.errors[0].message.message) {
                            this.errorSaveStore(result.data.errors[0].message.message);
                        } else {
                            this.errorSaveStore("Falha ao salvar registro.");
                        }
                    } else {
                        this.storeSuccessSaved();
                        this.prepareBookstoreFormAfterSave(result.data.data.saveBookstoreRegister.group_id);
                        setTimeout(
                            this.searchBookstore(null), 3000
                        );
                    }
                }).catch(err => {
                    let errorMessage = 'Falha ao salvar registro.';
                    if(err != null && err !== undefined && err.message !=null && err.message !== undefined && err.message !== "") {
                        errorMessage = err.message;
                    }
                    this.errorSaveStore(errorMessage);
                });
        }
    }

    private storeSuccessSaved() {
        this.openAlert(true, 'success', 'Cadastro realizado com sucesso.');
    }

    private errorSaveStore(msg: string) {
        this.openAlert(true, 'error', msg || 'Erro. Verifique se o email já existe e se a senha segue as regras para cadastro.');
    }

    private openAlert(alertOpened: boolean, alertType: string, alertMessage: string) {
        this.setState({ alertType })
        this.setState({ alertMessage })
        this.setState({ alertOpened })
    }

    private closeAlert = (event: object, reason: string) => {
        if (reason === 'clickaway') {
            return;
        }
        this.setState({ alertOpened: false });
    }

    private handleChangeCadastro = (param: any) => (event: React.FormEvent<HTMLInputElement>) => {
        const store = Object.assign({}, this.state.store);
        store[param] = event.currentTarget.value;
        this.setState({ store });
    };

    private handleChangeSelect = (event: any) => {
        const store = Object.assign({}, this.state.store);
        store[event.target.name] = event.target.value;
        this.setState({ store });
    };

    private handleClearAllForm = () => {
        const store = {
            address: '',
            alerta_dias_sem_venda: 0,
            cnpj: '',
            cnpj_monitoria_coletor: '',
            county: '',
            erp_coleta_venda: '',
            group_id: 0,
            group_name:'',
            id: 0,
            ignore_discount: false,
            name: '',
            preprd_id: 0,
            state: '',
            tipo_coleta_venda: '',
            zipcode: ''
        };

        this.searchBookstore(store);

        this.setState({
            store,
            value: ''
        });
    }

    private prepareBookstoreFormAfterSave = (groupId:number) => {

        if(!groupId) {
            groupId = this.state.store.group_id;
        }

        this.setState({
            store: {
                address: '',
                alerta_dias_sem_venda: 0,
                cnpj: '',
                cnpj_monitoria_coletor: '',
                county: '',
                erp_coleta_venda:'',
                group_id: groupId,
                group_name: this.state.store.group_name,
                id: 0,
                ignore_discount: false,
                name: '',
                preprd_id: 0,
                state: '',
                tipo_coleta_venda: '',
                zipcode: ''
            }
        });
    }

    private getSuggestions = (input:any) => {
        const inputValue = input.value.trim().toLowerCase();
        const inputLength = inputValue.length;

        const fixedSuggestions = this.state.fixedSuggestions;

        return fixedSuggestions.filter(sug => 
                sug.name.toLowerCase().slice(0, inputLength) === inputValue
            );
    };

    private getSuggestionValue = (suggestion:any) => suggestion.name;

    private renderSuggestion = (suggestion:any) => {
        return (
            <Paper className="suggestion">
                <span>
                    {suggestion.name}
                </span>
            </Paper>
        );
    }

    private onChange = (event:object, newValue:any) => {
        this.setState({
            value: newValue.newValue
        });
        this.syncEconomicGroupStatusValue(newValue.newValue);
    };
    
    private onSuggestionsFetchRequested = (value:any) => {
        this.setState({
            suggestions: this.getSuggestions(value)
        });
    };
    
    private onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: []
        });
    };

    private onSuggestionSelected = (event:object, selected: any ) => {
        const store = Object.assign({}, this.state.store);
        store.group_id = selected.suggestion.id;
        store.group_name = selected.suggestion.name;

        this.setState({ store });
    }

    private syncEconomicGroupStatusValue = (inputValue:string) => {

        if(!inputValue) {
            inputValue = this.state.value;
        }

        const store = Object.assign({}, this.state.store);

        if(store.group_name) {
            if(store.group_name !== inputValue) {
                store.group_id = 0;
                store.group_name = inputValue;
            }
        } else {
            store.group_id = 0;
            if(inputValue) {
                store.group_name = inputValue;
            }
        }

        this.setState( {store} );
    }
}



// WEBPACK FOOTER //
// ./src/component/administration/registers/bookstores/BookstoresRegister.tsx